<template lang="pug">
  .PeriodInterval
    .PeriodInterval-select
      custom-select(
        placeholder='Начальный период',
        :isBoldSelected='true',
        :hasError='hasError',
        :hasWarning='hasWarning',
        @input='updateSelection("from", $event)',
        :options="list",
        :value="currentSelection[0]")
    .PeriodInterval-delimiter -
    .PeriodInterval-select
      custom-select(
        @input='updateSelection("to", $event)',
        :isBoldSelected='true',
        :hasError='hasError',
        :hasWarning='hasWarning',
        placeholder='Конечный период',
        :options="list",
        :value="currentSelection[1]")
</template>

<script>
import CustomSelect from '@/components/CustomSelect'
import periods from '@/mixins/periods'

export default {
  name: 'period-interval',
  components: { CustomSelect },
  props: {
    initialSelection: {
      type: Array,
      default: () => {
        return []
      }
    },
    hasError: Boolean,
    hasWarning: Boolean
  },
  mixins: [periods],
  data() {
    return {
      currentSelection: [null, null]
    }
  },
  computed: {
    list() {
      return this.periodsDates.map((v) => {
        return {
          id: v.id,
          name: v.dateStart + ' - ' + v.dateEnd
        }
      })
    }
  },
  watch: {
    list(newVal) {}
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.initialSelection.length > 0) {
        this.initialSelection.sort((x, y) => {
          const xIndex = this.list.findIndex((v) => v.id === x)
          const yIndex = this.list.findIndex((v) => v.id === y)
          return xIndex < yIndex ? -1 : xIndex > yIndex ? 1 : 0
        })
        this.currentSelection = []
        const indexFrom = this.list.findIndex((v) => v.id === this.initialSelection[0])
        const indexTo = this.initialSelection[1] ? this.list.findIndex((v) => v.id === this.initialSelection[this.initialSelection.length - 1]) : indexFrom
        this.currentSelection.push(indexFrom > -1 ? this.list[indexFrom] : null)
        this.currentSelection.push(indexTo > -1 ? this.list[indexTo] : null)
        this.currentSelection = [].concat(this.currentSelection)
      }
    },
    updateSelection(type, value) {
      if (type === 'to') {
        this.currentSelection[1] = value
      } else {
        this.currentSelection[0] = value
      }
      let indexFrom = this.list.findIndex((v) => this.currentSelection[0] && v.id === this.currentSelection[0].id)
      let indexTo = this.list.findIndex((v) => this.currentSelection[1] && v.id === this.currentSelection[1].id)
      if (indexFrom > indexTo && type === 'from') {
        this.currentSelection[1] = this.currentSelection[0]
        indexTo = indexFrom
      } else if (indexFrom > indexTo && type === 'to') {
        this.currentSelection[0] = this.currentSelection[1]
        indexFrom = indexTo
      }
      this.currentSelection = [].concat(this.currentSelection)
      const allPeriods = this.list.slice(indexFrom, indexTo + 1).map((v) => v.id)
      this.$emit('select', allPeriods)
    }
  }
}
</script>
<style scoped lang="scss">
@import '~base';
.PeriodInterval {
  display: flex;
  align-items: center;

  &-select {
    min-width: 207px;
    height: 28px;
    border-radius: 14px;
  }

  &-delimiter {
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PeriodInterval.vue